import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NotificationService } from "libs/platform-pages/src/lib/api/notification/notification.service";
import { MhNotificationSettings } from "libs/platform-pages/src/lib/api/notification/notification.types";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { take } from "rxjs";

@Component({
  selector: "mh-mission-partner-dashboard-notification-settings",
  templateUrl: "./mission-partner-dashboard-notification-settings.component.html",
  styleUrls: ["./mission-partner-dashboard-notification-settings.component.less"],
})
export class MissionPartnerDashboardNotificationSettingsComponent {
  @Input() notificationsSettings!: MhNotificationSettings;

  constructor(
    private mhNotificationService: NotificationService,
    private nzNotificationService: NzNotificationService,
    private translateService: TranslateService,
  ) {}

  updateNotificationSettings() {
    this.mhNotificationService
      .saveNotificationSettings(this.notificationsSettings)
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          this.nzNotificationService.success("", this.translateService.instant("notification-settings.update.success"));
        }
      });
  }
}
